import { api } from "api";
import React, { Fragment } from 'react';
import { Field } from 'redux-form';
import {
    renderNumberKG,
    renderTimeField,
    AsyncSelectField,
    renderNumberG,
    renderNumberPercentage,
} from '../../../../Utils/renderField/renderField';
import CardEmpty from "Utils/Cards/CardEmpty";
import Modal from 'react-responsive-modal';
import { NotificationManager } from "react-notifications";
import Alerta from "../../../../Utils/Alerta/Alerta";
import { RenderNumber } from "../../../../Utils/renderField/renderReadField";
import { aplicarVariacionDRC } from "../../../../Utils/LaboratorioDRC/Common";

/**
 * Función para obtener los laboratoristas de sólidos
 * @param {*} search Laboratorista a buscar
 * @returns {Promise} Promise con los resultados de la búsqueda
 */
const getLaboratoristasSolidos = search => {
    return api.get('laboratorista/listar_laboratoristas_solidos', { search })
        .then(data => {
            if (data) {
                return data.results;
            }
            return [];
        }).catch(() => ([]));
}

/**
 * Componente para renderizar el modal de DRC
 * Se creó para refactorizar el contenido en el componente general (LaboratorioSolidoForm)
 * Solo se hicieron cambios respectivos a la variación DRC
 * @param {function} setDRCTemp Función para establecer el DRC temporal
 * @param {*} props Propiedades del componente
 * @returns {JSX.Element} Componente de modal de DRC
 */
export const ModalDRC = (props) => {
    const { fields, setDRCTemp, drc_temporal, clearDRCTemp,
        closeModal, open_drc, updateData,
        drc_promedio_1, drc_promedio_2, drc_promedio_3,
        alerta, texto_alerta,
        variacionDRC = {}, mostrarVariacionDRC } = props;

    return (
        <Modal open={open_drc} onClose={() => { closeModal() }} closeOnEsc={false} closeOnOverlayClick={false}>
            <h2>DATOS DRC</h2>
            <div className="form-group grid-container d-flex align-items-center flex-column">
                {!!alerta && (
                    <Alerta texto={texto_alerta} danger={true} />
                )}
            </div>
            <div className="row p-0">
                <div className="col-12">
                    <div className="row p-0">
                        {/* PESO MUESTRA (P1) */}
                        <div className="col-12 col-md-4 p-0">
                            <div className="col-md-12 col-sm-12">
                                <label htmlFor="peso_muestra" className="m-0">PESO MUESTRA (P1)</label>
                            </div>
                            <div className="col-md-12  form-group">
                                <Field name="peso_muestra" component={renderNumberKG} type="text"
                                    className="form-control"
                                    input={{
                                        value: drc_temporal['peso_muestra'], onChange: (e) => {
                                            setDRCTemp('peso_muestra', parseFloat(e));
                                        }
                                    }}
                                />
                            </div>
                        </div>
                        {/* PESO CREPA (P2) */}
                        <div className="col-12 col-md-4 p-0">
                            <div className="col-md-12 col-sm-12">
                                <label htmlFor="peso_crepa" className="m-0">PESO CREPA (P2)</label>
                            </div>
                            <div className="col-md-12  form-group">
                                <Field name="peso_crepa" component={renderNumberKG} type="text"
                                    className="form-control"
                                    input={{
                                        value: drc_temporal['peso_crepa'], onChange: (e) => {
                                            setDRCTemp('peso_crepa', parseFloat(e));
                                        }
                                    }}
                                />
                            </div>
                        </div>
                        {/* VARIACIÓN DRC */}
                        {mostrarVariacionDRC &&
                            <div className="col-12 col-md-4 p-0">
                                <div className="col-md-12 col-sm-12">
                                    <label htmlFor="peso_crepa" className="m-0">VARIACIÓN DRC</label>
                                </div>
                                <div className="col-md-12  form-group">
                                    {variacionDRC.aplica ?
                                        <RenderNumber value={variacionDRC.variacion} decimalScale={2}
                                            className="datos-drc-solidos-edicion__dato-variacion" suffix=" %" />
                                        :
                                        <span className="datos-drc-solidos-edicion__dato-variacion">No aplica</span>
                                    }
                                </div>
                            </div>
                        }
                    </div>
                    <div className="row p-0">
                        {/* PESO HÚMEDO 1RO. */}
                        <div className="col-12 col-md-4 p-0">
                            <div className="col-md-12 col-sm-12">
                                <label htmlFor="peso_humedo_1" className="m-0">PESO HÚMEDO 1RO.</label>
                            </div>
                            <div className="col-md-12  form-group">
                                <Field name="peso_humedo_1" component={renderNumberG} type="text"
                                    className="form-control"
                                    input={{
                                        value: drc_temporal['peso_humedo_1'], onChange: (e) => {
                                            setDRCTemp('peso_humedo_1', parseFloat(e));
                                        }
                                    }}
                                />
                            </div>
                        </div>
                        {/* PESO HÚMEDO 2DO. */}
                        <div className="col-12 col-md-4 p-0">
                            <div className="col-md-12 col-sm-12">
                                <label htmlFor="peso_humedo_2" className="m-0">PESO HÚMEDO 2DO.</label>
                            </div>
                            <div className="col-md-12  form-group">
                                <Field name="peso_humedo_2" component={renderNumberG} type="text"
                                    className="form-control"
                                    input={{
                                        value: drc_temporal['peso_humedo_2'], onChange: (e) => {
                                            setDRCTemp('peso_humedo_2', parseFloat(e));
                                        }
                                    }}
                                />
                            </div>
                        </div>
                        {/* PESO HÚMEDO 3RO. */}
                        <div className="col-12 col-md-4 p-0">
                            <div className="col-md-12 col-sm-12">
                                <label htmlFor="peso_humedo_3" className="m-0">PESO HÚMEDO 3RO.</label>
                            </div>
                            <div className="col-md-12  form-group">
                                <Field name="peso_humedo_3" component={renderNumberG} type="text"
                                    className="form-control"
                                    input={{
                                        value: drc_temporal['peso_humedo_3'], onChange: (e) => {
                                            setDRCTemp('peso_humedo_3', parseFloat(e));
                                        }
                                    }}
                                />
                            </div>
                        </div>

                        {/* PESO SECO 1RO. */}
                        <div className="col-12 col-md-4 p-0">
                            <div className="col-md-12 col-sm-12">
                                <label htmlFor="peso_seco_1_original" className="m-0">PESO SECO 1RO.</label>
                            </div>
                            <div className="col-md-12  form-group">
                                <Field name="peso_seco_1_original" component={renderNumberG} type="text"
                                    className="form-control"
                                    input={{
                                        value: drc_temporal['peso_seco_1_original'], onChange: (e) => {
                                            setDRCTemp('peso_seco_1_original', parseFloat(e));
                                            if (variacionDRC.aplica) {
                                                setDRCTemp('peso_seco_1', aplicarVariacionDRC(parseFloat(e), variacionDRC.variacion));
                                            } else {
                                                setDRCTemp('peso_seco_1', parseFloat(e));
                                            }
                                        }
                                    }}
                                />
                            </div>
                        </div>
                        {/* PESO SECO 2DO. */}
                        <div className="col-12 col-md-4 p-0">
                            <div className="col-md-12 col-sm-12">
                                <label htmlFor="peso_seco_2_original" className="m-0">PESO SECO 2DO.</label>
                            </div>
                            <div className="col-md-12  form-group">
                                <Field name="peso_seco_2_original" component={renderNumberG} type="text"
                                    className="form-control"
                                    input={{
                                        value: drc_temporal['peso_seco_2_original'], onChange: (e) => {
                                            setDRCTemp('peso_seco_2_original', parseFloat(e));
                                            if (variacionDRC.aplica) {
                                                setDRCTemp('peso_seco_2', aplicarVariacionDRC(parseFloat(e), variacionDRC.variacion));
                                            } else {
                                                setDRCTemp('peso_seco_2', parseFloat(e));
                                            }
                                        }
                                    }}
                                />
                            </div>
                        </div>
                        {/* PESO SECO 3RO. */}
                        <div className="col-12 col-md-4 p-0">
                            <div className="col-md-12 col-sm-12">
                                <label htmlFor="peso_seco_3_original" className="m-0">PESO SECO 3RO.</label>
                            </div>
                            <div className="col-md-12  form-group">
                                <Field name="peso_seco_3_original" component={renderNumberG} type="text"
                                    className="form-control"
                                    input={{
                                        value: drc_temporal['peso_seco_3_original'], onChange: (e) => {
                                            setDRCTemp('peso_seco_3_original', parseFloat(e));
                                            if (variacionDRC.aplica) {
                                                setDRCTemp('peso_seco_3', aplicarVariacionDRC(parseFloat(e), variacionDRC.variacion));
                                            } else {
                                                setDRCTemp('peso_seco_3', parseFloat(e));
                                            }
                                        }
                                    }}
                                />
                            </div>
                        </div>

                        {/* HORA INGRESO */}
                        <div className="col-12 col-md-4 p-0">
                            <div className="col-md-12 col-sm-12">
                                <label htmlFor="hora_ingreso" className="m-0">HORA INGRESO</label>
                            </div>
                            <div className="col-md-12  form-group">
                                <Field name="hora_ingreso" component={renderTimeField} type="text"
                                    className="form-control"
                                    input={{
                                        value: drc_temporal['hora_ingreso'], onChange: (e) => {
                                            setDRCTemp('hora_ingreso', e);
                                        }
                                    }}
                                />
                            </div>
                        </div>
                        {/* HORA SALIDA */}
                        <div className="col-12 col-md-4 p-0">
                            <div className="col-md-12 col-sm-12">
                                <label htmlFor="hora_salida" className="m-0">HORA SALIDA</label>
                            </div>
                            <div className="col-md-12  form-group">
                                <Field name="hora_salida" component={renderTimeField} type="text"
                                    className="form-control"
                                    input={{
                                        value: drc_temporal['hora_salida'], onChange: (e) => {
                                            setDRCTemp('hora_salida', e);
                                        }
                                    }}
                                />
                            </div>
                        </div>
                        {/* LABORATORISTA */}
                        <div className="col-12 col-md-4 p-0">
                            <div className="col-md-12 col-sm-12">
                                <label htmlFor="laboratorista" className="m-0">LABORATORISTA</label>
                            </div>
                            <div className="col-md-12  form-group">
                                <Field
                                    name="laboratorista"
                                    valueKey="id"
                                    labelKey="nombre"
                                    label="nombre"
                                    component={AsyncSelectField}
                                    // loadOptions={getUsuarios}
                                    loadOptions={getLaboratoristasSolidos}
                                    input={{
                                        value: drc_temporal['laboratorista'], onChange: (e) => {
                                            setDRCTemp('laboratorista', e);
                                            setDRCTemp('laboratorista_nombre', e.nombre);
                                        }
                                    }}
                                />
                            </div>
                        </div>

                        {/* RESULTADOS DRC */}
                        <div className="col-12 mt-4">
                            <CardEmpty noShadow>
                                {/* PESOS CON VARIACIÓN DRC APLICADA */}
                                {variacionDRC.aplica && mostrarVariacionDRC &&
                                    <Fragment>
                                        <h6 className="text-center mb-3">PESOS CON VARIACIÓN DRC APLICADA</h6>
                                        <div className="col-12 row mr-3 mb-2">
                                            <div className="col-12 col-md-4 p-0">
                                                <div className="col-md-12 col-sm-12">
                                                    <label htmlFor="peso_seco_1" className="m-0">PESO SECO 1RO.</label>
                                                </div>
                                                <div className="col-md-12  form-group">
                                                    <Field name="peso_seco_1" disabled component={renderNumberG} type="text"
                                                        className="form-control"
                                                        input={{
                                                            value: drc_temporal['peso_seco_1']
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-4 p-0">
                                                <div className="col-md-12 col-sm-12">
                                                    <label htmlFor="peso_seco_2" className="m-0">PESO SECO 2DO.</label>
                                                </div>
                                                <div className="col-md-12  form-group">
                                                    <Field name="peso_seco_2" disabled component={renderNumberG} type="text"
                                                        className="form-control"
                                                        input={{
                                                            value: drc_temporal['peso_seco_2']
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-4 p-0">
                                                <div className="col-md-12 col-sm-12">
                                                    <label htmlFor="peso_seco_3" className="m-0">PESO SECO 3RO.</label>
                                                </div>
                                                <div className="col-md-12  form-group">
                                                    <Field name="peso_seco_3" disabled component={renderNumberG} type="text"
                                                        className="form-control"
                                                        input={{
                                                            value: drc_temporal['peso_seco_3']
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </Fragment>
                                }

                                {/* DRC */}
                                <div className="col-12 row mr-3 mb-3">
                                    <div className="col-12 col-md-4 p-0">
                                        <div className="col-md-12 col-sm-12">
                                            <label htmlFor="drc_promedio_1" className="m-0">DRC 1RO.</label>
                                        </div>
                                        <div className="col-md-12  form-group">
                                            <Field name="drc_promedio_1" disabled component={renderNumberPercentage} type="text"
                                                className="form-control"
                                                input={{
                                                    value: drc_promedio_1
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-4 p-0">
                                        <div className="col-md-12 col-sm-12">
                                            <label htmlFor="drc_promedio_2" className="m-0">DRC 2DO.</label>
                                        </div>
                                        <div className="col-md-12  form-group">
                                            <Field name="drc_promedio_2" disabled component={renderNumberPercentage} type="text"
                                                className="form-control"
                                                input={{
                                                    value: drc_promedio_2
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-4 p-0">
                                        <div className="col-md-12 col-sm-12">
                                            <label htmlFor="drc_promedio_3" className="m-0">DRC 3RO.</label>
                                        </div>
                                        <div className="col-md-12  form-group">
                                            <Field name="drc_promedio_3" disabled component={renderNumberPercentage} type="text"
                                                className="form-control"
                                                input={{
                                                    value: drc_promedio_3
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </CardEmpty>
                        </div>
                    </div>
                </div>
            </div>
            <div className="buttons-box mt-5">
                <button className="btn btn-outline-dark mr-5"
                    onClick={e => {
                        e.preventDefault();
                        closeModal()
                    }}>
                    CANCELAR
                </button>
                <button type="submit" className="btn btn-primary"
                    disabled={!!alerta ? true : false}
                    onClick={(e) => {
                        e.preventDefault();
                        if (!drc_temporal.laboratorista) {
                            NotificationManager.error('Ingrese el laboratorista', 'ERROR', 3000);
                        }
                        if (!drc_temporal.hora_ingreso) {
                            NotificationManager.error('Ingrese la hora de ingreso.', 'ERROR', 3000);
                        }

                        if (drc_temporal.peso_crepa && drc_temporal.peso_muestra) {
                            // const { drc_promedio_1, drc_promedio_2, drc_promedio_3 } = calcularDRCSolidos(drc_temporal);
                            drc_temporal.drc_promedio_1 = drc_promedio_1;
                            drc_temporal.drc_promedio_2 = drc_promedio_2;
                            drc_temporal.drc_promedio_3 = drc_promedio_3;

                            if (drc_promedio_1 && drc_promedio_2 && drc_promedio_3) {
                                drc_temporal.drc_promedio_total =
                                    (drc_promedio_1 + drc_promedio_2 + drc_promedio_3) / 3
                            }

                            if (drc_temporal.laboratorista) {
                                if (drc_temporal.hasOwnProperty('index'))
                                    updateData(drc_temporal, 'drc');
                                else
                                    fields.push(drc_temporal);
                                clearDRCTemp();
                                closeModal();
                            }
                        }
                    }}
                >
                    GUARDAR
                </button>
            </div>
        </Modal>
    )
};
